// extracted by mini-css-extract-plugin
export default {"base":"Multisector_base__5Vive","error":"Multisector_error__a3Yv5"};